import { useCallback } from 'react';
import type React from 'react';

import type { UtilityContext } from '@change-corgi/core-react/utilityContext';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { LazyComponent } from '#src/app/shared/components/layout/lazy';

import type { FlyerDownload } from './components/FlyerDownload';

async function LoadFlyerDownload({ errorReporter }: UtilityContext): Promise<typeof FlyerDownload | (() => null)> {
	try {
		return (await import(/* webpackChunkName: "pages/starter-dashboard-qr-code-flyer" */ './components/FlyerDownload'))
			.FlyerDownload;
	} catch (error) {
		const err = error instanceof Error ? error : new Error('Unknown error: Failed to load FlyerDownload component');
		void errorReporter.report({ error: err, params: { event: 'LoadFlyerDownload' } });
		return () => null;
	}
}

export const FlyerDownloadLoader: React.FC = () => {
	const utilityContext = useUtilityContext();
	const loadComponent = useCallback(async () => LoadFlyerDownload(utilityContext), [utilityContext]);

	return <LazyComponent loadComponent={loadComponent} fallback={<div></div>} />;
};
